import { useEffect, useState } from "react";
import api from "../api/api";

function AdminPayments() {
  const [payments, setPayments] = useState([]);
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    api.get("/payment/all")
      .then(res => setPayments(Array.isArray(res.data) ? res.data : []))
      .catch(() => setPayments([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="text-muted fs-13">Loading payments…</p>;

  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title">💳 All Payments</div>
        <span className="badge badge-muted">{payments.length} records</span>
      </div>

      {payments.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">💳</div>
          <div className="empty-title">No payments yet</div>
        </div>
      ) : (
        <div className="card-body no-pad">
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Subscriber</th>
                  <th>Amount</th>
                  <th>Mode</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {payments.map(p => (
                  <tr key={p.paymentId}>
                    <td><strong>{p.userName}</strong></td>
                    <td className="text-gold fw-700 font-serif">₹{p.amount}</td>
                    <td><span className="badge badge-info">{p.paymentMode || "—"}</span></td>
                    <td>
                      <span className={`badge ${p.status === "SUCCESS" ? "badge-success" : "badge-warning"}`}>
                        {p.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminPayments;
